<div
    class="container-fluid well"
    data-test-automation="plan-details">
    <h5>Plan Details</h5>

    <div class="row">
        <div class="col-xs-2">
            <label class="control-label required-input">Tenure type</label>
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <ng-select
                    class="nlr-ng-select"
                    [searchable]="false"
                    [clearable]="false"
                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                    name="tenureType"
                    id="tenureType"
                    placeholder="Select"
                    [items]="tenureTypes"
                    bindLabel="name"
                    [(ngModel)]="getModel().tenureType"
                    (change)="tenureTypeChange($event)">
                </ng-select>
            }
        </div>

        <div class="col-xs-2">
            <label class="control-label required-input">Plan type</label>
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div>
                    <ng-select
                        class="nlr-ng-select"
                        [searchable]="false"
                        [clearable]="false"
                        [disabled]="getModel().tenureType === undefined || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        name="planType"
                        id="planType"
                        placeholder="Select"
                        [items]="planTypes"
                        bindLabel="name"
                        [(ngModel)]="getModel().planType"
                        (change)="planTypeChange($event)"
                        required>
                    </ng-select>
                </div>
            }
        </div>

        <div class="col-xs-2">
            <label class="control-label required-input">Plan number</label>
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div
                    class="input-group"
                    [ngClass]="{'has-error':planNumberInput.invalid && planNumberInput.dirty}">
                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                    <input
                        type="number"
                        class="form-control"
                        name="planNumber"
                        id="planNumber"
                        #planNumberInput="ngModel"
                        [disabled]="isAmendmentOrReplacementPlan()|| readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        min="0"
                        maxlength="8"
                        [maxLengthInputLimit]="8"
                        (blur)="planNumberChange()"
                        placeholder="Enter plan number"
                        title="Enter the plan number for the plan"
                        [(ngModel)]="getModel().planNumber"
                        required
                        data-test-automation="plan-number" />
                </div>
            }
        </div>

        <div class="col-xs-4">
            <label class="control-label required-input">Plan purpose</label>
            <div
                class="input-group"
                data-test-automation="plan-purpose">
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <div>
                        <ng-select
                            class="nlr-ng-select"
                            [searchable]="false"
                            [clearable]="false"
                            [disabled]="getModel().tenureType === undefined || getModel().planType === undefined || readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                            name="planPurpose"
                            id="planPurpose"
                            placeholder="Select"
                            [items]="planPurposes"
                            bindLabel="name"
                            [ngModel]="getModel().planPurpose"
                            (change)="planPurposeChange($event)"
                            required>
                        </ng-select>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-6">
            <label
                class="control-label"
                [ngClass]="{'required-input': isPlanHeadingMandatory()}"
                for="planHeading"
                >Plan heading</label
            >
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div
                    class="input-group"
                    [ngClass]="{'has-error': isPlanHeadingMandatory() && planHeadingInput.invalid && planHeadingInput.dirty}">
                    <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                    <textarea
                        class="form-control"
                        name="planHeading"
                        id="planHeading"
                        [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly || isPlanHeadingAutoGenerated()"
                        #planHeadingInput="ngModel"
                        placeholder="{{getToolTip()}}"
                        rows="4"
                        cols="60"
                        maxlength="2000"
                        [(ngModel)]="getModel().planHeading"
                        title="{{getToolTip()}}"
                        [required]="isPlanHeadingMandatory()"
                        data-test-automation="plan-heading">
                    </textarea>
                </div>
            }
        </div>
        <div class="col-xs-6">
            <label
                class="control-label"
                for="customerReference"
                >Customer reference</label
            >
            @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                <div class="input-group">
                    <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                    <input
                        type="text"
                        id="customerReference"
                        name="customerReference"
                        class="form-control"
                        #customerReferenceInput="ngModel"
                        [(ngModel)]="getModel().customerReference"
                        placeholder="Enter customer reference"
                        nlrFocus
                        maxlength="30"
                        autocomplete="off"
                        title="Enter your reference"
                        [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || readonly"
                        data-test-automation="customer-reference" />
                </div>
            }
        </div>
    </div>
</div>
<!--TODO
<div class="help-block">
  <span>Error!</span>
  <span>{{groups.planInformation.invalidPlanDetailsText}}</span>
</div>
-->
